<template>
  <div class="detail-dialog">
    <el-drawer
      :title="title"
      :visible.sync="isShow"
      :direction="direction"
      :before-close="handleClose"
      size="952px"
    >
      <div class="detail-dialog-main">
        <div class="list-table-item">
          <div class="list-table-item__left">
            <div class="flex flex-column-center padding-top_7 padding-bottom_7">
              <img
                v-if="detail.businessType==1"
                src="@/assets/img/client/check/Express.png"
                width="16"
                height="16"
              >
              <img
                v-else-if="detail.businessType==2"
                src="@/assets/img/client/check/Air.png"
                width="16"
                height="16"
              >
              <img
                v-else-if="detail.businessType==3"
                src="@/assets/img/client/check/Ocean.png"
                width="16"
                height="16"
              >
              <img
                v-else-if="detail.businessType==4"
                src="@/assets/img/client/check/Ocean.png"
                width="16"
                height="16"
              >
              <div class="margin-left_8">
                <span class="text1">{{ getMode(detail) }}</span>
                <el-divider direction="vertical" />
                <span>
                  <span class="text2">预计</span>
                  <span class="text1">{{ detail.workDays }} </span>
                  <span class="text2">天</span>
                </span>
              </div>
            </div>
            <div class="flex flex-column-center">
              <div class="flex flex-1 flex-column-center padding-top_6 padding-bottom_6">
                <div class="flex flex-column-center">
                  <img
                    src="@/assets/img/client/check/address-icon.png"
                    alt="air"
                    width="16"
                    height="16"
                  >
                  <span class="text1 margin-left_8">{{ `${GetStartAddress(detail)}` }}</span>
                </div>
                <div class="line margin-left_8 margin-right_8" />
                <div class="flex flex-column-center">
                  <img
                    src="@/assets/img/client/check/air-icon.png"
                    alt="air"
                    width="16"
                    height="16"
                  >
                </div>
                <div class="line margin-left_8 margin-right_8" />
                <div class="flex flex-column-center">
                  <img
                    src="@/assets/img/client/check/address-icon.png"
                    alt="air"
                    width="16"
                    height="16"
                  >
                  <span class="text1 margin-left_8">{{ `${GetDestAddress(detail)}` }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="list-table-item__center">
            <div v-if="detail.totalAmount>0" class="padding-top_5 padding-bottom_5 text1">CNY ￥{{ detail.totalAmount }}</div>
            <div v-else class="padding-top_5 padding-bottom_5 text1">单询</div>
            <div class="flex flex-row-center padding-top_7 padding-bottom_7">
              <div class="text2">价格有效期：</div>
              <div class="text3">{{ detail.expirationTimeCn }}</div>
            </div>
          </div>
        </div>
        <div class="address-title flex flex-column-center padding-left_16 margin-top_16">
          <img src="@/assets/img/client/check/detail1.png" alt="detail" width="16" height="16">
          <span class="margin-left_8">{{ `${GetStartAddress(detail)} > ${GetDestAddress(detail)}` }}</span>
        </div>
        <div class="detail-table">
          <div class="detail-table-tr">
            <div class="detail-table-td">
              <span class="title">费用代码</span>
            </div>
            <div class="detail-table-td">
              <span class="title">费用名称</span>
            </div>
            <div class="detail-table-td">
              <span class="title">费用描述</span>
            </div>
            <div class="detail-table-td"><span class="title">计费数量</span></div>
            <div class="detail-table-td"><span class="title">单价</span></div>
            <div class="detail-table-td"><span class="title">费用</span></div>
          </div>
          <div v-if="detail.pickupAmount>0" class="detail-table-tr">
            <div class="detail-table-td">
              <span class="text">PICKUP</span>
            </div>
            <div class="detail-table-td">
              <span class="text">Pickup Fee</span>
            </div>
            <div class="detail-table-td">
              <span class="text">Pickup Fee</span>
            </div>
            <div class="detail-table-td"><span class="text"> {{ detail.pickupChargeWeight }} </span></div>
            <div class="detail-table-td">
              <span class="text">CNY ￥{{ (detail.pickupAmount/item.pickupChargeWeight).toFixed(3) }}</span>
            </div>
            <div class="detail-table-td">
              <span class="text1">CNY ￥{{ detail.pickupAmount.toFixed(2) }}</span>
            </div>
          </div>
          <div v-if="detail.startLiftgateAmount>0" class="detail-table-tr">
            <div class="detail-table-td">
              <span class="text">LIFT</span>
            </div>
            <div class="detail-table-td">
              <span class="text">Lift Gate Charge</span>
            </div>
            <div class="detail-table-td">
              <span class="text">Flat Fee</span>
            </div>
            <div class="detail-table-td"><span class="text">1</span></div>
            <div class="detail-table-td">
              <span class="text">CNY ￥{{ detail.startLiftgateAmount }}</span>
            </div>
            <div class="detail-table-td">
              <span class="text1">CNY ￥{{ detail.startLiftgateAmount }}</span>
            </div>
          </div>
          <div v-for="(item,index) in detail.feeList" :key="index" class="detail-table-tr">
            <div class="detail-table-td">
              <span class="text">{{ item.code }}</span>
            </div>
            <div class="detail-table-td">
              <span class="text">{{ item.name }}</span>
            </div>
            <div class="detail-table-td">
              <span class="text">{{ item.comment }}</span>
            </div>
            <div class="detail-table-td"><span class="text">{{ item.units }}</span></div>
            <div class="detail-table-td">
              <span v-if="item.amount>0" class="text">CNY ￥{{ item.unitPrice.toFixed(2) }}</span>
              <span v-else class="text">单询</span>
            </div>
            <div class="detail-table-td">
              <span v-if="item.amount>0" class="text1">CNY ￥{{ item.amount }}</span>
              <span v-else class="text1">单询</span>
            </div>
          </div>
          <div v-if="detail.bondAmount>0" class="detail-table-tr">
            <div class="detail-table-td">
              <span
                class="text"
              >{{ detail.bondType === 1 ?'Single Entry Bond(based on goods value of USD' + detail.GoodsValue + ')' : 'Annual bond' }}</span>
            </div>
            <div class="detail-table-td">
              <span class="text">-</span>
            </div>
            <div class="detail-table-td">
              <span class="text">-</span>
            </div>
            <div class="detail-table-td"><span class="text">1</span></div>
            <div class="detail-table-td">
              <span class="text">CNY ￥{{ detail.bondAmount.toFixed(2) }}</span>
            </div>
            <div class="detail-table-td">
              <span class="text1">CNY ￥{{ detail.bondAmount.toFixed(2) }}</span>
            </div>
          </div>
          <div v-if="detail.destLiftgateAmount>0" class="detail-table-tr">
            <div class="detail-table-td">
              <span class="text">LIFT</span>
            </div>
            <div class="detail-table-td">
              <span class="text">Lift Gate Charge</span>
            </div>
            <div class="detail-table-td">
              <span class="text">Flat Fee</span>
            </div>
            <div class="detail-table-td"><span class="text">1</span></div>
            <div class="detail-table-td">
              <span class="text">CNY ￥{{ detail.destLiftgateAmount }}</span>
            </div>
            <div class="detail-table-td">
              <span class="text1">CNY ￥{{ detail.destLiftgateAmount }}</span>
            </div>
          </div>
          <div v-if="detail.ISFBondAmount>0" class="detail-table-tr">
            <div class="detail-table-td">
              <span class="text">ISF Bond</span>
            </div>
            <div class="detail-table-td">
              <span class="text">ISF Bond</span>
            </div>
            <div class="detail-table-td">
              <span class="text">ISF Bond</span>
            </div>
            <div class="detail-table-td"><span class="text">1</span></div>
            <div class="detail-table-td">
              <span class="text">CNY ￥{{ detail.ISFBondAmount }}</span>
            </div>
            <div class="detail-table-td">
              <span class="text1">CNY ￥{{ detail.ISFBondAmount }}</span>
            </div>
          </div>
          <div v-if="detail.insuranceAmount>0" class="detail-table-tr">
            <div class="detail-table-td">
              <span class="text">保险费 (货值：${{ detail.GoodsValue }})</span>
            </div>
            <div class="detail-table-td">
              <span class="text">-</span>
            </div>
            <div class="detail-table-td">
              <span class="text">-</span>
            </div>
            <div class="detail-table-td"><span class="text">1</span></div>
            <div class="detail-table-td">
              <span class="text">CNY ￥{{ detail.insuranceAmount }}</span>
            </div>
            <div class="detail-table-td">
              <span class="text1">CNY ￥{{ detail.insuranceAmount }}</span>
            </div>
          </div>
          <!-- <div class="detail-table-tr detail-table-tr1">
            <div class="detail-table-td">
              <span class="text2">小计</span><span class="text1">: CNY ￥{{ detail.totalAmount }}</span>
            </div>
          </div> -->
          <div class="detail-table-tr detail-table-tr2">
            <div class="detail-table-td">
              <span v-if="detail.totalAmount>0" class="text3">总计: CNY ￥{{ detail.totalAmount }}</span>
              <span v-else class="text3">总计: 单询</span>
            </div>
          </div>
        </div>
        <div v-if="!!detail.detailList && detail.detailList.length > 0" class="card-remarks">
          <p v-for="( item, index ) in detail.detailList " :key="index">{{ item.moduleName }}:
            <span>{{ item.content }}</span>
          </p>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  name: 'DetailDialog',
  components: {},
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    direction: {
      type: String,
      default: 'rtl'
    },
    title: {
      type: String,
      default: '明细'
    },
    detail: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    handleClose() {
      this.$emit('close', false)
    },
    getBusinessType(item) {
      switch (item.businessType) {
        case 1:
          return `Express`
        case 2:
          return `Air`
        case 3:
          return `Ocean`
        case 4:
          return `Ocean`
      }
    },
    getMode(item) {
      switch (item.businessType) {
        case 1:
          return `国际快递 `
        case 2:
          return `空运 | (${this.GetType(item)})`
        case 3:
          return `海运`
        case 4:
          return `海运 | (${this.GetType(item)})`
      }
    },
    GetStartAddress(item) {
      console.log(item)
      switch (item.businessType) {
        case 1:
          return `${item.originZipcode},${item.originNameCn} `
        case 2:
          return `${item.startPortCode}`
        case 3:
          return `${item.OriginAddressCode}`
        case 4:
          return `${item.startPortCode}`
      }
    },
    GetDestAddress(item) {
      switch (item.businessType) {
        case 1:
          return `${item.destinationZipcode},${item.destinationName}`
        case 2:
          return `${item.destPortCode}`
        case 3:
          return `${item.DestinationAddressCode}`
        case 4:
          return `${item.destPortCode}`
      }
    },
    GetType(item) {
      switch (item.businessType) {
        case 2:
          switch (item.calculationType) {
            case 1:
              return `门到门`
            case 2:
              return `门到机场`
            case 3:
              return `机场到机场`
            case 4:
              return `机场到门`
          }
          break
        case 4:
          switch (item.calculationType) {
            case 1:
              return `门到门`
            case 2:
              return `门到港口`
            case 3:
              return `港口到港口`
            case 4:
              return `港口到门`
          }
          break
      }
      return ''
    }
  }
}
</script>

<style scoped lang="scss">
	.detail-dialog {
		& ::v-deep .el-drawer__wrapper {
			.el-drawer__header {
				height: 56px;
				padding: 0 24px;
				margin: 0;
				align-items: center;
				text-align: left;
				justify-content: space-between;
				border: 1px solid #ebebeb;
				box-sizing: border-box;

				span {
					display: inline-block;
					font-family: PingFangSC, PingFang SC;
					font-weight: 500;
					font-size: 14px;
					color: #333333;
					line-height: 24px;
					text-align: left;
					font-style: normal;
				}

				.el-drawer__close-btn {
					font-size: 18px;
				}
			}
		}

		.card-remarks {
			width: 863px;
			height: 161px;
			background: rgba(0, 0, 0, 0.02);
			border-radius: 8px;
			margin: 16px;
			text-align: left;
			overflow-y: scroll;

			p {
				padding: 4px 8px;
				margin: 0;
			}

			span {
				padding: 0 8px;
				display: block;
			}
		}

		.detail-dialog-main {
			padding: 16px 24px;
			box-sizing: border-box;

			.list-table-item {
				// width: 1200px;
				padding: 8px 0;
				display: flex;
				align-items: stretch;
				background: rgba(51, 112, 255, 0.06);
				border-radius: 4px;
				transition: border 0.3s;
				box-sizing: border-box;

				// &:hover {
				//   border: 1px solid #3370ff;
				// }
				.list-table-item__left {
					flex: 1;
					padding: 0 16px;
					box-sizing: border-box;

					.filter-button1 {
						display: inline-block;
						min-width: 64px;
						min-height: 24px;
						padding: 3px 8px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 600;
						font-size: 12px;
						color: #3370ff;
						line-height: 17px;
						// text-align: center;
						font-style: normal;
						background: rgba(2, 127, 252, 0.08);
						border-radius: 8px 0px 8px 0px;
						box-sizing: border-box;
					}

					.text1 {
						display: inline-block;
						font-family: D, D;
						font-weight: normal;
						font-size: 14px;
						color: #333333;
						line-height: 16px;
						text-align: left;
						font-style: normal;
					}

					.text2 {
						display: inline-block;
						font-family: D, D;
						font-family: PingFangSC, PingFang SC;
						font-size: 14px;
						color: #333333;
						line-height: 16px;
						text-align: left;
						font-style: normal;
					}

					.line {
						width: 16px;
						height: 1px;
						background: #aaaaaa;
					}

					.inline-ask-btn {
						width: 96px;
						height: 32px;
						background: rgba(51, 112, 255, 0.04);
						border-radius: 8px;
						box-sizing: border-box;

						span {
							display: inline-block;
							font-family: PingFangSC, PingFang SC;
							font-weight: 500;
							font-size: 13px;
							color: #3370ff;
							line-height: 18px;
							text-align: left;
							font-style: normal;
						}

						&:hover {
							cursor: pointer;
						}
					}
				}

				.list-table-item__center {
					width: 256px;
					padding-right: 16px;
					border-left: 1px solid #dddddd;
					box-sizing: border-box;

					.text1 {
						font-family: D-DINExp, D-DINExp;
						font-weight: bold;
						font-size: 20px;
						color: #333333;
						line-height: 22px;
						text-align: center;
						font-style: normal;

						&::after {
							position: relative;
							top: -8px;
							left: 3px;
							display: inline-block;
							font-family: D, D;
							font-weight: normal;
							font-size: 12px;
							color: #333333;
							line-height: 13px;
							text-align: left;
							font-style: normal;
						}
					}

					.text2 {
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 13px;
						color: #aaaaaa;
						line-height: 18px;
						text-align: left;
						font-style: normal;
					}

					.text3 {
						font-family: D, D;
						font-weight: normal;
						font-size: 13px;
						color: #333333;
						line-height: 18px;
						text-align: left;
						font-style: normal;
					}

					.text4 {
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 13px;
						color: #333333;
						line-height: 18px;
						text-align: left;
						font-style: normal;
					}
				}
			}

			.address-title {
				height: 40px;
				text-align: left;
				background: rgba(170, 170, 170, 0.08);
				box-sizing: border-box;

				span {
					display: inline-block;
					font-family: PingFangSC, PingFang SC;
					font-weight: 500;
					font-size: 14px;
					color: #333333;
					line-height: 20px;
					text-align: left;
					font-style: normal;
				}
			}

			.detail-table {
				width: 100%;

				.detail-table-tr {
					display: flex;
					align-items: center;

					border-bottom: 1px solid #eee;

					.title {
						display: inline-block;
						font-family: PingFangSC, PingFang SC;
						font-weight: 550;
						font-size: 13px;
						color: #333333;
						line-height: 18px;
						text-align: left;
						font-style: normal;
					}

					.text {
						display: inline-block;
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 13px;
						color: #333333;
						line-height: 18px;
						text-align: left;
						font-style: normal;
					}

					.text1 {
						display: inline-block;
						font-family: D-DINExp, D-DINExp;
						font-weight: bold;
						font-size: 13px;
						color: #333333;
						line-height: 14px;
						text-align: right;
						font-style: normal;
					}

					.text2 {
						font-family: PingFangSC, PingFang SC;
						font-weight: 600;
						font-size: 13px;
						color: #333333;
						line-height: 18px;
						text-align: right;
						font-style: normal;
					}

					.text3 {
						display: inline-block;
						font-family: D-DINExp, D-DINExp;
						font-weight: bold;
						font-size: 16px;
						color: #333333;
						line-height: 17px;
						text-align: right;
						font-style: normal;
					}

					& .detail-table-td {
						height: 40px;
						text-align: left;
						padding: 11px 8px;
					}

					& .detail-table-td:nth-child(1) {
						width: 152px;
						box-sizing: border-box;
					}

					& .detail-table-td:nth-child(2) {
						width: 240px;
						box-sizing: border-box;
					}

					& .detail-table-td:nth-child(3) {
						width: 128px;
						box-sizing: border-box;
					}

					& .detail-table-td:nth-child(4) {
						width: 120px;
						box-sizing: border-box;
					}

					& .detail-table-td:nth-child(5) {
						width: 120px;
						box-sizing: border-box;
					}

					& .detail-table-td:nth-child(6) {
						width: 144px;
						text-align: right;
						box-sizing: border-box;
					}
				}

				.detail-table-tr1 {
					border: none;

					.detail-table-td {
						text-align: right;
						width: 100% !important;
					}
				}

				.detail-table-tr2 {
					border: none;
					background: rgba(2, 127, 252, 0.08);

					.detail-table-td {
						padding: 11px 16px;
						text-align: right;
						width: 100% !important;
					}
				}
			}

			.detail-tip {
				padding: 8px;
				background: rgba(0, 0, 0, 0.02);
				border-radius: 8px;
				box-sizing: border-box;

				.detail-tip-title {
					font-family: PingFangSC, PingFang SC;
					font-weight: 600;
					font-size: 13px;
					color: #333333;
					line-height: 18px;
					text-align: left;
					font-style: normal;
				}

				.detail-tip-text {
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					font-size: 13px;
					color: #333333;
					line-height: 18px;
					text-align: left;
					font-style: normal;
				}
			}
		}
	}
</style>
